export default __webpack_public_path__ + "static/media/planit_logo_light_full.7d227700.svg";